import { withChartLayout } from 'components/common';
import RoleRelationship from 'components/features/chart/admission-history/role-relationship/RoleRelationship';

const RoleRelationshipPage = withChartLayout('Role - Relationship')(RoleRelationship);
export default RoleRelationshipPage;
